//Actions
import {
  SET_CONTACTS_DATA,
  SET_CONTACTS_LOADER,
  SET_CONTACTS_LABELS,
  SET_CONTACTS_FILTERS,
  CLEAR_CONTACTS_FILTERS,
  LOGOUT,
  SET_RETURN_ADDRESSES_DATA,
  SET_CONTACT_NOTES_DATA,
  SET_CONTACT_NOTES_LOADER,
  CREATE_CONTACT_NOTE,
  DELETE_CONTACT_NOTE,
  UPDATE_SINGLE_CONTACT,
} from '../actions/action-types';

const initialState = {
  contacts: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalContactsInDB: null,
  loading: false,
  labels: [],
  applyFilters: false,
  filterSize: null,
  filters: {},
  returnAddresses: [],
  contactNotes: [],
  contactNotesLoader: false,
};

const contactsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CONTACTS_DATA:
      return {
        ...state,
        contacts: payload.rows,
        rowsCount: payload.count,
        totalContactsInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_CONTACTS_LOADER:
      return { ...state, loading: payload };
    case SET_CONTACTS_LABELS:
      return { ...state, labels: payload };
    case SET_CONTACTS_FILTERS:
      return {
        ...state,
        applyFilters: payload.applyFilters,
        filterSize: payload.filterSize,
        filters: payload.filters,
      };
    case CLEAR_CONTACTS_FILTERS:
      return { ...state, applyFilters: false, filterSize: null, filters: {} };
    case SET_RETURN_ADDRESSES_DATA:
      return { ...state, returnAddresses: payload };
    case SET_CONTACT_NOTES_DATA:
      return { ...state, contactNotes: payload };
    case SET_CONTACT_NOTES_LOADER:
      return { ...state, contactNotesLoader: payload };
    case CREATE_CONTACT_NOTE:
      return { ...state, contactNotes: [...state.contactNotes, payload] };
    case DELETE_CONTACT_NOTE:
      return {
        ...state,
        contactNotes: state.contactNotes.filter((note) => note.id !== payload.id),
      };
    case UPDATE_SINGLE_CONTACT:
      const updatedContacts = state.contacts.map((contact) =>
        String(contact.id) === String(payload.id) ? { ...contact, ...payload } : contact
      );
      return {
        ...state,
        contacts: [...updatedContacts], // Create new array reference
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { contactsReducers };
